import React from 'react'

import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

interface ScheduleWizardButtonProps {
  icon: JSX.Element
  name: string
  subtitle: string | number
  step: number
  currentStep: number
  maxConfiguredStep: number
  onClick: () => void
}

const ScheduleWizardButton = (props: ScheduleWizardButtonProps): JSX.Element => {
  const isStepDisabled = props.step > props.maxConfiguredStep

  return (
    <Stack flex={props.step === 4 ? 0 : 1} sx={{ position: 'relative' }}>
      {props.step !== 4 && (
        <Stack
          sx={{
            position: 'absolute',
            left: 64,
            right: 0,
            top: 29,
            height: 2,
            opacity: 0.5,
            backgroundColor: props.step >= props.maxConfiguredStep ? 'text.disabled' : 'primary.main',
          }}
        />
      )}
      <Button
        disabled={isStepDisabled}
        variant={props.currentStep === props.step ? 'contained' : 'outlined'}
        sx={{ height: 60, width: 60, mb: 2 }}
        aria-label={props.name}
        onClick={props.onClick}
      >
        {props.icon}
      </Button>
      <Typography variant="subtitle2" color={isStepDisabled ? 'text.disabled' : 'text.primary'}>
        {props.name}
      </Typography>
      <Typography variant="caption" color={isStepDisabled ? 'text.disabled' : 'text.primary'}>
        {props.subtitle}
      </Typography>
    </Stack>
  )
}

export default ScheduleWizardButton
